export const isEnvConfEnabled = (configName) => {
  return process.env[configName] === 'true';
}